import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { BusinessService } from '../business.service';
import { Business } from '../business.model';
import { CardModule } from 'primeng/card';
import { BusinessUnitsService } from '../../business-units/business-units.service';
import { EntityDropdownPickerComponent } from '../../../shared/components/entity-dropdown-picker/entity-dropdown-picker.component';
import { EntityDropdownPickerAdapter } from '../../../shared/components/entity-dropdown-picker/entity-dropdown-picker.model';
import { BusinessUnit } from '../../business-units/business-unit.model';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { IftaLabelModule } from 'primeng/iftalabel';
@Component({
  selector: 'app-business-form',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    ToastModule,
    CardModule,
    InputGroupModule,
    InputGroupAddonModule,
    IftaLabelModule,
    EntityDropdownPickerComponent,
  ],
  templateUrl: './business-form.component.html',
  providers: [MessageService],
})
export class BusinessFormComponent implements OnInit {
  businessId: number | null = null;
  businessForm!: FormGroup;
  isEditMode = false;
  pageTitle = 'Create New Business';
  businessUnitPickerAdapter!: EntityDropdownPickerAdapter<BusinessUnit>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private businessService: BusinessService,
    private businessUnitsService: BusinessUnitsService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.businessUnitPickerAdapter = this.businessUnitsService.createBusinessUnitPickerAdapter();
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.businessId = +id;
        this.isEditMode = true;
        this.pageTitle = 'Edit Business';
        this.loadBusinessData(this.businessId);
      }
    });
  }

  initForm(): void {
    this.businessForm = this.fb.group({
      businessName: ['', Validators.required],
      businessCode: [''],
      businessUnit: [null, Validators.required],
      arAccount: [''],
      apAccount: [''],
      reference: [''],
    });
  }

  loadBusinessData(id: number): void {
    this.businessService.getBusinessById(id).subscribe({
      next: (business) => {
        this.businessForm.patchValue(business);
        if (business.businessUnitId) {
          this.businessUnitsService.getBusinessUnitById(business.businessUnitId).subscribe({
            next: (businessUnit) => this.businessForm.patchValue({ businessUnit }),
          });
        }
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load business unit data.',
        });
        console.error(err);
      },
    });
  }
  saveBusiness(): void {
    if (this.businessForm.invalid) {
      this.businessForm.markAllAsTouched();
      return;
    }

    const businessData: Business = {
      id: this.businessId ?? 0,
      businessName: this.businessForm.value.businessName,
      businessCode: this.businessForm.value.businessCode,
      businessUnitId: this.businessForm.value.businessUnit?.id,
      arAccount: this.businessForm.value.arAccount,
      apAccount: this.businessForm.value.apAccount,
      reference: this.businessForm.value.reference,
    };
    console.log(this.businessForm.value);
    const operation = this.isEditMode
      ? this.businessService.updateBusiness(businessData)
      : this.businessService.createBusiness(businessData);

    operation.subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Business ${
            this.isEditMode ? 'updated' : 'created'
          } successfully.`,
        });
        setTimeout(
          () =>
            this.router.navigate([
              '/ai-studio/session/current',
              { outlets: { canvasOutlet: ['business', 'list'] } },
            ]),
          1500
        );
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to ${this.isEditMode ? 'update' : 'create'} branch.`,
        });
        console.error(err);
      },
    });
  }

  cancel(): void {
    this.router.navigate([
      '/ai-studio/session/current',
      { outlets: { canvasOutlet: ['business', 'list'] } },
    ]);
  }
}
